import { render } from "./FileUploadComponent.vue?vue&type=template&id=65d54d89"
import script from "./FileUploadComponent.vue?vue&type=script&lang=js"
export * from "./FileUploadComponent.vue?vue&type=script&lang=js"

import "./FileUploadComponent.vue?vue&type=style&index=0&id=65d54d89&lang=css"

import exportComponent from "/var/www/mcd-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__